import type { FormField } from '@cli-types/core-engine/schema.js'
import { isSupportedFormFieldType } from '@core-engine/schema/type-mappers/validation/is-supported-form-field-type.js'
import { unsupportedFormFieldTypeMessage } from '@core-engine/schema/type-mappers/validation/unsupported-form-field-type-message.js'

export function collectInvalidFormFieldTypeErrors(fields: FormField[], errors: string[]): void {
  for (const field of fields) {
    if (!isSupportedFormFieldType(field)) {
      errors.push(unsupportedFormFieldTypeMessage(field))
    }

    if (field.fields) {
      collectInvalidFormFieldTypeErrors(field.fields, errors)
    }
  }
}
